var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailBrandFilled = function SvgMailBrandFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m2.251 5.899 8.598 7.51a1.75 1.75 0 0 0 2.302 0l8.598-7.51c.081.191.126.401.126.622v10.958c0 .88-.715 1.596-1.595 1.596H3.72c-.88 0-1.595-.716-1.595-1.596V6.521c0-.22.045-.43.126-.622m.66-.752c.237-.14.514-.222.81-.222H20.28c.295 0 .572.081.81.222l-8.596 7.508a.75.75 0 0 1-.987 0z",
    clipRule: "evenodd"
  })));
};
export default SvgMailBrandFilled;